module.exports = __webpack_public_path__ + "8c4b23e9f1431f345ebe31202cce9e22.MP3";